import { render, staticRenderFns } from "./DotPlotSkills.vue?vue&type=template&id=0b85d383&"
import script from "./DotPlotSkills.vue?vue&type=script&lang=js&"
export * from "./DotPlotSkills.vue?vue&type=script&lang=js&"
import style0 from "./DotPlotSkills.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports